// Single source of truth for interpreting a supplier's free-text invoice_rules
// into VAT behavior. Shared by the upload review screen (UploadDocumentPage)
// and the document edit screen (DocumentViewPage) so both honor the same rule.
//
//   • VAT-inclusive — prices already include VAT, no separate VAT line → force vat=0
//   • Partial VAT   — variable VAT driven by item mix (produce exempt) → keep the
//                     printed/saved VAT value instead of auto-computing 18%
//
// The trigger phrases below mirror the patterns the rule-learning flow writes.
// VAT-inclusive requires the EXPLICIT "don't add a VAT line" instruction; merely
// mentioning "כולל מע\"מ" is not enough (some suppliers include VAT yet still
// break it out in the summary). Partial VAT keys on "חלקי" near מע, or "פטור".
//
// docType makes the rule document-type-aware: a חשבונית מרכזת (consolidated
// invoice) is the tax document that consolidates a month of delivery notes, and
// it DOES break out VAT even for suppliers whose delivery notes are VAT-exempt
// (e.g. produce). So a force-vat=0 rule (vatInclusive) is downgraded to "keep
// the printed VAT" (partialVat) on a מרכזת — the delivery notes still get vat=0.
export function detectVatRule(invoiceRules, docType) {
  const rules = (invoiceRules || '').toLowerCase();
  const vatInclusiveRaw = /אל תוסיף.*מע|לא תוסיף.*מע|לא להוסיף.*מע|אין שורת מע|ללא שורת מע/.test(rules);
  const partialVatRaw = !vatInclusiveRaw && /חלקי.*מע|מע.*חלקי|פטור/.test(rules);
  const isConsolidatedInvoice = docType === 'חשבונית מרכזת';
  const vatInclusive = vatInclusiveRaw && !isConsolidatedInvoice;
  const partialVat = partialVatRaw || (vatInclusiveRaw && isConsolidatedInvoice);
  return { vatInclusive, partialVat };
}
